import { IconBathtub, IconBed } from '@propertyfinder/icons';
import { Fragment, h } from 'preact';

import { SaveSearchModel } from 'common/data/save-search/model';
import { SaveSearchPayloadFilterKeysEnum } from 'common/data/save-search/payload-filter-keys.enum';
import { createAlertCardGetFilterValue } from 'common/module/create-alert/card/getFilterValue';

export const createAlertCardGetFilters = (filtersValue: SaveSearchModel['filters'], separator: string = '|'): any => {
  let message: any;

  if (filtersValue[SaveSearchPayloadFilterKeysEnum.BEDROOMS]?.length) {
    message = (
      <div>
        <IconBed /> {createAlertCardGetFilterValue(filtersValue[SaveSearchPayloadFilterKeysEnum.BEDROOMS])}
      </div>
    );
  }

  if (filtersValue[SaveSearchPayloadFilterKeysEnum.BATHROOMS]?.length) {
    const bathValue = (
      <div>
        <IconBathtub /> {createAlertCardGetFilterValue(filtersValue[SaveSearchPayloadFilterKeysEnum.BATHROOMS])}
      </div>
    );
    if (message) {
      message = (
        <Fragment>
          {message} <div className={'separator'}>{` ${separator} `}</div> {bathValue}
        </Fragment>
      );
    } else {
      message = bathValue;
    }
  }

  return message;
};
